import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlightConfirmationComponent } from './flight-confirmation/flight-confirmation.component';
import { AuthenticationGuard } from '../core/services/auth/authentication.guard';
import { PermissionGuard } from '../core/services/permission/permission.guard';

const routes: Routes = [
  { path: 'confirmation', component: FlightConfirmationComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FlightRoutingModule { }
